import katex from 'katex'
import 'katex/dist/katex.min.css'

/**
 * Render LaTeX formulas in content
 * Supports both inline ($...$) and block ($$...$$) formulas
 */
function looksLikeCurrency(formula) {
  return /^\d/.test(formula)
}

function containsHtmlArtifacts(formula) {
  return /<[^>]+>/.test(formula) || /&[a-zA-Z]+;/.test(formula) || /&#\d+;/.test(formula)
}

export function renderLatex(content) {
  if (!content || typeof content !== 'string') return content

  // Process block formulas first ($$...$$)
  let result = content.replace(/\$\$([\s\S]*?)\$\$/g, (match, formula) => {
    if (containsHtmlArtifacts(formula)) return match
    try {
      return katex.renderToString(formula.trim(), {
        displayMode: true,
        throwOnError: false,
        strict: false
      })
    } catch (e) {
      console.warn('KaTeX block render error:', e)
      return match
    }
  })

  // Process inline formulas ($...$)
  // Use negative lookbehind to avoid matching $$ or escaped \$
  result = result.replace(/(?<!\$)\$(?!\$)((?:[^$\\]|\\.)+?)\$/g, (match, formula) => {
    if (looksLikeCurrency(formula)) return match
    if (containsHtmlArtifacts(formula)) return match
    if (formula.length > 200) return match
    try {
      return katex.renderToString(formula.trim(), {
        displayMode: false,
        throwOnError: false,
        strict: false
      })
    } catch (e) {
      console.warn('KaTeX inline render error:', e)
      return match
    }
  })

  return result
}

/**
 * Check if content contains LaTeX formulas
 */
export function hasLatex(content) {
  if (!content || typeof content !== 'string') return false
  // Check for $...$ or $$...$$ patterns
  return /\$\$[\s\S]*?\$\$|\$(?!\$)[^$]+\$/.test(content)
}

export default {
  renderLatex,
  hasLatex
}
